import React, { useRef, useState } from 'react';
import { PreviewIcon } from '../../../components/icons/PreviewIcon';
import CustomModal from '../../../components/CustomModal';
import { FrameContainer } from '../../../components/DocumentViewer/DocumentViewer';
import { queryConfig } from '../../../api/queryBase';

const BusinessDocumentViewer = ({
    url,
    ext,
    useApi = false
}: {
    url: string;
    ext: string;
    useApi?: boolean;
}) => {
    const [visibleDocument, setVisibleDocument] = useState(false);
    const iframeRef = useRef(null);

    const query = queryConfig({ isBlob: true });
    const { isLoading, data } = query<Blob>({
        url: url,
        cacheKey: url,
        enabled: useApi
    });

    const newFileUrl = data?.payload ? URL.createObjectURL(data.payload) : null;

    return (
        <div>
            <div
                className='cursor-pointer'
                onClick={() => {
                    setVisibleDocument(true);
                }}
            >
                <PreviewIcon />
            </div>
            <CustomModal
                maxWidth='max-content'
                open={visibleDocument}
                onClose={() => setVisibleDocument(false)}
                title=''
                styles={{
                    width: '100%',
                    paddingTop: '10px'
                }}
            >
                <div className='lg:w-[32rem] w-full h-[85vh]'>
                    <FrameContainer>
                        {ext === 'pdf' ? (
                            <iframe
                                title='PDF File Viewer'
                                ref={iframeRef}
                                src={(useApi ? newFileUrl : url) || ''}
                                frameBorder='0'
                                scrolling='no'
                                style={{
                                    width: '100%',
                                    height: '100%'
                                }}
                            />
                        ) : (
                            <img
                                src={(useApi ? newFileUrl : url) || ''}
                                alt={ext}
                                style={{ width: '100%' }}
                            />
                        )}
                    </FrameContainer>
                </div>
            </CustomModal>
        </div>
    );
};

export default BusinessDocumentViewer;
